<template>
  <v-row class="align-center">
    <v-col cols="3" class="subtitle-2">Resort Fee</v-col>
    <v-col>
      <v-text-field v-currency="currency" outlined hide-details dense :value="formattedNumber" @input="updateValue"
    /></v-col>
  </v-row>
</template>

<script>
import moneyService from "@/services/money";
export default {
  props: {
    value: Object,
  },
  computed: {
    supplierEnv() {
      return this.$store.getters["SupplierStore/env"];
    },
    currency() {
      const source = moneyService.getCurrencySource(this.supplierEnv);
      return {
        currency: source.currency,
        locale: "en-US",
        prefix: source.currency_symbol,
      };
    },
    formattedNumber() {
      if (!this.value?.value) return "";
      return moneyService.stripFormatting(this.value.value, this.supplierEnv);
    },
  },
  methods: {
    updateValue(newPercent) {
      if (!newPercent) {
        this.$emit("input", null);
        return;
      }
      this.$emit("input", {
        ...this.value,
        value: newPercent,
        cur: this.currency.currency,
      });
    },
    clear() {
      this.$emit("input", null);
    },
  },
};
</script>
